<template>
  <div v-if="level" class="access-block">
    <slot :level="level" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const VIEWER_LEVEL = 'viewer';

/**
 * Applies the access level of one catalog block (ADR 0006 D4, revised 2026-10-07): no level →
 * nothing, viewer → `accessBlock.isReadOnly` injected (the block disables itself through
 * `BlockFieldset`; frames of the view stay usable), editor → unchanged. Switch off:
 * `getAccessLevel` returns editor.
 */
export default {
  name: 'AccessBlock',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  provide() {
    const accessBlock = {};
    // Getter, so injecting components follow level changes reactively.
    Object.defineProperty(accessBlock, 'isReadOnly', {
      enumerable: true,
      get: () => this.isReadOnly,
    });
    return { accessBlock };
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    level() {
      return this.getAccessLevel(this.id);
    },
    isReadOnly() {
      return this.level === VIEWER_LEVEL;
    },
  },
};
</script>
